<template>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                    New Inquiry
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-card-title class="headline">
                                    Inquiries
                                </v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        clearable
                                ></v-text-field>
                            </v-card-title>

                            <v-layout row class="statusBar">

                                <template
                                        v-for="(item, index) in status">
                                    <v-hover v-show="item.active">
                                        <v-flex slot-scope="{ hover }" @click="setActiveStatus(item.id)" ml-2 mr-2
                                                pa-2 xs12
                                                class="statusBarItemActive">
                                            <div class="text-xs-center">
                                                <div class="statusName">{{item.name}}</div>
                                                <div class="statusCountActive">{{item.count}}</div>
                                            </div>
                                        </v-flex>
                                    </v-hover>
                                    <v-hover v-show="!item.active">
                                        <v-flex slot-scope="{ hover }" @click="setActiveStatus(item.id)" ml-2 mr-2
                                                pa-2 xs12

                                                :class="`${hover ? 'statusBarItemHover' :'statusBarItem'}`">
                                            <div class="text-xs-center">
                                                <div class="statusName">{{item.name}}</div>
                                                <div :class="`${hover ? 'statusCountHover' :'statusCount'}`">
                                                    {{item.count}}
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-hover>
                                </template>

                            </v-layout>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>

                                <!--    v-touch="{right: () => openDialog(props.item.id)}"              -->

                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.customer.name }}</td>
                                        <td class="text-xs-left">{{ props.item.project_number }}</td>
                                        <td class="text-xs-left">{{ props.item.rfq_number }}</td>
                                        <td class="text-xs-left">
                                            <div :class="deadlineColor(props.item.deadline)"> {{ props.item.deadline
                                                |
                                                toDateTime }}
                                            </div>
                                        </td>
                                        <td class="text-xs-left">{{ props.item.account.firstname}} {{
                                            props.item.account.lastname}}
                                        </td>
                                        <td class="text-xs-left">
                                            <v-progress-linear v-if="props.item.inquiries_status_id > 1"
                                                               slot="progress"
                                                               :value="calculateProgress(props.item.id)"
                                                               :color="color(props.item.id)"
                                                               height="7"
                                            ></v-progress-linear>
                                        </td>

                                        <td class="text-xs-center">
                                            {{ getOfferPositionCount(props.item.inquires_positions) }} / {{
                                            props.item.inquires_positions.length }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.inquiries_status.name }}</td>
                                        <td class="text-xs-left">{{ props.item.created_at | toDateTimeLocalTime }}</td>

                                    </v-touch>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <inquiryDialog></inquiryDialog>

            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
    import {
        Settings,
        Inquiry
    } from '../../store/namespace-helper'
    import inquiryDialog from '../Distribution/InquiryDialog.vue'
    import _ from 'lodash'
    import moment from 'moment'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {stateHelperMixin} from '../../mixins/stateHelperMixin'

    export default {
      name: 'inquiries',
      components: {
        inquiryDialog
      },
      mixins: [dateFunctionFilters, stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Inquriy-ID', value: 'id'},
                    {text: 'Customer', value: 'customers_id'},
                    {text: 'Project Number', value: 'project_number'},
                    {text: 'RFQ Number', value: 'rfq_number'},
                    {text: 'Deadline', value: 'deadline'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Progress', value: 'progress', sortable: false},
                    {text: 'Offers Positions', value: 'supplier_offers_positions', sortable: false},
                    {text: 'Status', value: 'inquiries_status.name', sortable: false},
                    {text: 'Created', value: 'created_at'}
          ],
          pagination: {'sortBy': 'deadline', 'ascending': true},
          search: '',
          regSearch: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [50, 10, 25, 50, 100, 250],
          status: [],
          activeStatus: {id: -1}
        }
      },
/*      created () {
        console.log('this.$route.params.id: ' + this.$route.params.id)
        if (this.$route.params.id > 0) {
          this.openDetailsById(null)
        }
      }, */
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadItems()
      },
      methods: {
        openDialog (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            this.$store.dispatch(Inquiry.actions.setSelectedInquiry, item)
          }
          this.$store.dispatch(Inquiry.actions.openCloseInquiryDialog)
        },
        openDetailsById (val) {
                /*                if (val !== null) {
                                    var item = this.getItems.find(x => x.id === val)
                                    this.$store.dispatch(Inquiry.actions.setSelectedInquiry, item)
                                } */

          this.$store.dispatch(Inquiry.actions.openCloseInquiryDialog)
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.regSearch ? this.regSearch : '',
            statusFilter: ['inquiries_status_id', this.activeStatus.id]
          }
          this.$store.dispatch(Inquiry.actions.loadInquiries, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        calculateProgress (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            return (100 / item.inquires_positions.length) * this.getOfferPositionCount(item.inquires_positions)
          } else {
            return 0
          }
        },
        color (val) {
          let item = this.getItems.find(x => x.id === val)
          if (this.getOfferPositionCount(item.inquires_positions) > item.inquires_positions.length) {
            return 'success'
          } else if (this.getOfferPositionCount(item.inquires_positions) === item.inquires_positions.length) {
            return 'warning'
          } else {
            return 'error'
          }
        },
        getOfferPositionCount (val) {
          let count = 0
          val.forEach(function (item) {
            count += item.supplier_offers_positions.length
          })
          return count
        },
        deadlineColor (deadline) {
          let duration = moment.duration(moment(deadline, 'YYYY-MM-DD hh:mm:ss').diff(moment()))
          let hours = duration.asHours()
          if (hours <= 24) {
            return 'deadlineFieldRed'
          } else if (hours <= 48) {
            return 'deadlineFieldYellow'
          } else {
            return 'deadlineFieldNormal'
          }
        },
        setActiveStatus (val) {
          console.log(this.status)
          let activateStatus = this.status.find(x => x.id === val)
          this.status.forEach((item, index) => {
            if (item.id === val) {
              item.active = true
                        // this.$set(this.status, index, item)
            } else {
              item.active = false
                        // this.$set(this.status, index, item)
            }
          })

          activateStatus.active = true
          this.activeStatus = activateStatus
          this.loadItems()
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[Inquiry.getters.inquiries].total
          this.status = this.$store.getters[Inquiry.getters.inquiries].statusGroups
          return this.$store.getters[Inquiry.getters.inquiries].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        dialog () {
          return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            if (val !== null) {
              this.regSearch = this.search.replace(/[^a-z0-9]/gi, '')
            } else {
              this.regSearch = ''
            }
            this.throttledLoadItems()
          },
          deep: true
        },
        dialog: {
          handler (val) {
            if (val === false) {
              this.loadItems()
            }
          }
        },
        deep: true
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

    .deadlineFieldRed {
        white-space: nowrap;
        /*        background-color: rgba(255, 0, 0, 0.75);*/
        text-align: left;
        height: 44px;
        /* color: white;*/
        color: rgba(255, 0, 0, 0.75);
        font-weight: bold;
        /*        border-radius: 16px;*/
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldYellow {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(255, 194, 16, 0.83);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .deadlineFieldNormal {
        white-space: nowrap;
        text-align: left;
        height: 44px;
        color: rgba(0, 0, 0, 0.75);
        font-weight: bold;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .statusCount {
        display: inline;
        background-color: var(--secondary-color);
        text-align: center;
        height: 28px;

        color: white;
        /*        color: rgba(255, 0, 0, 0.75);*/
        font-weight: bold;
        border-radius: 16px;
        padding-bottom: 4px;
        padding-top: 4px;
        padding-left: 8px;
        padding-right: 8px;
    }

    .statusCountActive {
        display: inline;
        background-color: var(--primary-color);
        text-align: center;
        height: 28px;

        color: white;
        /*        color: rgba(255, 0, 0, 0.75);*/
        font-weight: bold;
        border-radius: 16px;
        padding-bottom: 4px;
        padding-top: 4px;
        padding-left: 8px;
        padding-right: 8px;
    }

    .statusCountHover {
        display: inline;
        background-color: var(--primary-color);
        text-align: center;
        height: 28px;

        color: white;
        /*        color: rgba(255, 0, 0, 0.75);*/
        font-weight: bold;
        border-radius: 16px;
        padding-bottom: 4px;
        padding-top: 4px;
        padding-left: 8px;
        padding-right: 8px;
    }

    .statusBar {
        overflow-y: auto;

    }

    .statusBarItem {
        white-space: nowrap;
        color: var(--secondary-color);
        cursor: pointer;

    }

    .statusBarItemActive {
        white-space: nowrap;
        border-bottom: 2px solid var(--primary-color);
        color: var(--primary-color);
        cursor: pointer;
    }

    .statusBarItemHover {
        white-space: nowrap;
        border-bottom: 2px solid var(--primary-color));
        color: var(--primary-color);
        cursor: pointer;
    }

    .statusName {
        display: inline-block;
        height: 42px;
        max-height: 42px;
        /*        min-width: 150px;*/
        padding: 16px;
        text-transform: uppercase;
        font-weight: bold;
    }


</style>



// WEBPACK FOOTER //
// src/components/Distribution/Distribution.vue